import {graphql, useMutation} from 'react-relay';

import type {unarchiveUserMutation} from '../../graphql/__generated__/unarchiveUserMutation.graphql';

const mutation = graphql`
  mutation unarchiveUserMutation($input: UnarchiveUserInput!) {
    unarchiveUser(input: $input) {
      clientMutationId
      user {
        __typename
        archived
      }
    }
  }
`;

function useUnarchiveUser(): [
  (userId: string, callback: () => void, onError?: (error: Error) => void) => void,
  boolean,
] {
  const [commit, isInFlight] = useMutation<unarchiveUserMutation>(mutation);

  return [
    (userId, callback, onError) => {
      commit({
        variables: {
          input: {
            userId,
          },
        },
        onCompleted() {
          callback();
        },
        onError(error) {
          console.error(error);
          onError?.(error);
        },
      });
    },
    isInFlight,
  ];
}

export default useUnarchiveUser;
